<div class="content centered">
    <div id="logo" class="logo">
      <img src="assets/images/logo.png">
    </div>

    <div class="login-button">
      <button type="button" id="login" (click)="login()">Log In</button>
    </div>
</div>